module.exports = __webpack_public_path__ + "static/media/templateActive.6f4444ea.svg";